import "core-js/modules/es6.function.name";
/*
 * @Author: 张宇 1204569549@qq.com
 * @Date: 2021-09-24 09:37:43
 * @LastEditors: 张宇 1204569549@qq.com
 * @LastEditTime: 2022-10-18 14:50:19
 * @FilePath: \screening-sys\src\store\getters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  language: function language(state) {
    return state.app.language;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  breadcrumb: function breadcrumb(state) {
    return state.app.breadcrumb;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  school_id: function school_id(state) {
    return state.user.school_id;
  },
  school: function school(state) {
    return state.user.school;
  },
  grade: function grade(state) {
    return state.user.grade;
  },
  clazz: function clazz(state) {
    return state.user.clazz;
  },
  area_code: function area_code(state) {
    return state.user.area_code;
  },
  area_name: function area_name(state) {
    return state.user.area_name;
  },
  whole_name: function whole_name(state) {
    return state.user.whole_name;
  },
  area_level: function area_level(state) {
    return state.user.area_level;
  },
  logintime: function logintime(state) {
    return state.user.logintime;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  addRoutes: function addRoutes(state) {
    return state.permission.addRoutes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  msgnum: function msgnum(state) {
    return state.user.msgnum;
  },
  customernum: function customernum(state) {
    return state.user.customernum;
  },
  telphone: function telphone(state) {
    return state.user.telphone;
  },
  username: function username(state) {
    return state.user.username;
  },
  address: function address(state) {
    return state.user.address;
  },
  ischildno: function ischildno(state) {
    return state.user.ischildno;
  },
  iscustomreceipt: function iscustomreceipt(state) {
    return state.user.iscustomreceipt;
  },
  issecret: function issecret(state) {
    return state.user.issecret;
  },
  isconfig: function isconfig(state) {
    return state.user.isconfig;
  },
  is_password_old: function is_password_old(state) {
    return state.user.is_password_old;
  },
  is_checkdata: function is_checkdata(state) {
    return state.user.is_checkdata;
  },
  grade_code: function grade_code(state) {
    return state.user.grade_code;
  },
  ischeckopen: function ischeckopen(state) {
    return state.user.ischeckopen;
  },
  //判断是否为江苏账号
  isJs: function isJs(state) {
    return state.user.isJs;
  },
  user_name: function user_name(state) {
    return state.user.user_name;
  },
  nickname: function nickname(state) {
    return state.user.nickname;
  },
  remark: function remark(state) {
    return state.user.remark;
  },
  dh_address: function dh_address(state) {
    return state.user.dh_address;
  },
  isJy: function isJy(state) {
    return state.user.isJy;
  },
  levelstr: function levelstr(state) {
    return state.user.levelstr;
  },
  //判断是否为安徽账号
  isAnhui: function isAnhui(state) {
    return state.user.isAnhui;
  },
  /* 数据可视化 */
  //关键指标
  key: function key(state) {
    return state.vision.key;
  },
  //分析项
  analysisType: function analysisType(state) {
    return state.vision.analysisType;
  },
  //分析维度
  analysisAxis: function analysisAxis(state) {
    return state.vision.analysisAxis;
  },
  //样本类型
  sampleType: function sampleType(state) {
    return state.vision.sampleType;
  },
  //对比项
  comparisonItem: function comparisonItem(state) {
    return state.vision.comparisonItem;
  },
  //龋均情况
  averageToothType: function averageToothType(state) {
    return state.vision.averageToothType;
  },
  //龋病情况
  dieaseToothType: function dieaseToothType(state) {
    return state.vision.dieaseToothType;
  },
  //超重与肥胖情况
  overWeightType: function overWeightType(state) {
    return state.vision.overWeightType;
  },
  //营养不良情况
  lessNutritionType: function lessNutritionType(state) {
    return state.vision.lessNutritionType;
  }
};
export default getters;